document.addEventListener('DOMContentLoaded', () => {

    let imagesSliders = document.querySelectorAll('.images-sliders');
    if(imagesSliders){
        imagesSliders.forEach((item)=>{
            new Swiper('.images-sliders', {
                loop: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-img-next",
                    prevEl: ".sw-but-img-prev",
                },
            });
        });
    }

    let swiperTop = document.querySelectorAll('.swiper-top');
    if(swiperTop){
        swiperTop.forEach((item)=>{
            new Swiper('.swiper-top', {
                loop: true,
                effect: "fade",
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.slider-pagination',
                    clickable: true,
                },
            });
        });
    }

    let sliderNavBlock = document.querySelectorAll('.slider-nav-block');
    let sliderNavSlider = document.querySelectorAll('.slider-nav-slide');
    if(sliderNavSlider){
        const sliderNavSlider = new Swiper('.slider-nav-slide', {
            /*Optional parameters*/
            navCount: this,
            loop: false,
            effect: "fade",
            autoHeight: true,
            fadeEffect: {
                "crossFade": true
            },
            breakpoints: {
                640: {
                    autoHeight: true,
                },
            },
        });
        sliderNavBlock.forEach(function(hB,hBc) {
            let hNav = hB.querySelectorAll('.h-nav-items');
            hNav.forEach(function(h_nav) {
                let navCount = h_nav.dataset.nav;
                h_nav.addEventListener('click', function(e){
                    e.preventDefault();
                    if(sliderNavBlock.length > 1){
                        sliderNavSlider[hBc].slideTo(navCount, 1000);
                    } else {
                        sliderNavSlider.slideTo(navCount, 1000);
                    }
                    hNav.forEach(function(h_nav) {
                        h_nav.classList.remove('active');
                    });
                    this.classList.add('active');
                });
                if(sliderNavBlock.length > 1){
                    sliderNavSlider[hBc].on('slideChange', function () {
                        hNav.forEach(function(h_nav) {
                            let navC = h_nav.dataset.nav;
                            h_nav.classList.remove('active');
                            if(sliderNavSlider[hBc].realIndex == navC){
                                h_nav.classList.add('active');
                            }
                        });
                    });
                } else {
                    sliderNavSlider.on('slideChange', function () {
                        hNav.forEach(function(h_nav) {
                            let navC = h_nav.dataset.nav;
                            h_nav.classList.remove('active');
                            if(sliderNavSlider.realIndex == navC){
                                h_nav.classList.add('active');
                            }
                        });
                    });
                }
            });
        });
    }

    let columnsSlide = document.querySelectorAll('.columns-slide');
    if(columnsSlide){
        columnsSlide.forEach((item)=> {
            new Swiper('.columns-slide', {
                loop: false,
                effect: "fade",
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: '.slider-pagination',
                    clickable: true,
                },
            });
        });
    }

    let gallerySlider = document.querySelectorAll('.gallery-slider');
    if(gallerySlider){
        gallerySlider.forEach((item)=> {
            new Swiper('.gallery-slider', {
                watchSlidesProgress: true,
                slidesPerView: 1,
                autoHeight: false,
                loop: true,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-but-next",
                    prevEl: ".sw-but-prev",
                },
                breakpoints: {
                    600: {
                        slidesPerView: 3,
                        autoHeight: true,
                        loop: false,
                    },
                },
            });
        });
    }

});